<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="11">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('table_search_placeholder') ||
                  '产品SKU编号/SKU名称/SKU品牌/NC物料编码/工厂/店铺/市场/市场/售卖标题/亚马逊SKU/ASIN/FNSKU/店铺品牌/运营人员 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-info"
              @click="$emit('putShelves')"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('btn_putShelves') || '上架' }}
            </b-button>
            <!-- <b-button
              size="sm"
              class="ml-2"
              variant="outline-primary"
              @click="$emit('followSale')"
              v-if="allow('F')"
            >
              <b-icon-capslock-fill></b-icon-capslock-fill>
              {{ $l('btn_followSale') || '跟卖' }}
            </b-button> -->
            <!-- <b-button
              size="sm"
              class="ml-2"
              variant="outline-primary"
              @click="$emit('crossSiteSales')"
              v-if="allow('C')"
            >
              <b-icon-capslock></b-icon-capslock>
              {{ $l('btn_crossSiteSales') || '跨站点售卖' }}
            </b-button> -->
            <el-badge :value="checkedCount" class="ml-2" v-if="allow('N')">
              <b-button
                size="sm"
                variant="outline-warning"
                @click="$emit('unsaleable')"
                :disabled="!checkedCount"
              >
                <b-icon-archive></b-icon-archive>
                {{ $l('btn_unsaleable') || '不可售' }}
              </b-button>
            </el-badge>
            <el-badge :value="checkedCount" class="ml-2" v-if="allow('S')">
              <b-button
                size="sm"
                variant="outline-success"
                @click="$emit('availableSale')"
                :disabled="!checkedCount"
              >
                <b-icon-archive-fill></b-icon-archive-fill>
                {{ $l('btn_availableSale') || '可售' }}
              </b-button>
            </el-badge>
            <!-- <el-badge :value="checkedCount" class="ml-2" v-if="allow('X')">
              <b-button
                size="sm"
                variant="outline-danger"
                @click="$emit('disableDisplay')"
                :disabled="!checkedCount"
              >
                <b-icon-x-circle></b-icon-x-circle>
                {{ $l('btn_disableDisplay') || '禁止显示' }}
              </b-button>
            </el-badge> -->
            <el-badge :value="checkedCount" class="ml-2" v-if="allow('O')">
              <b-button
                size="sm"
                variant="outline-primary"
                @click="$emit('set-operate')"
                :disabled="!checkedCount"
              >
                {{ $l('btn_setOperate') || '更新运营人员' }}
              </b-button>
            </el-badge>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="exportFile"
              v-if="allow('E')"
            >
              {{ $l('INDEX.btn_export') || '导出' }}
            </b-button>
            <el-badge :value="checkedCount" class="ml-2" v-if="allow('R')">
              <b-button
                size="sm"
                variant="outline-primary"
                @click="$emit('restocking')"
                :disabled="!checkedCount"
              >
                {{ $l('btn_view_restocking') || '可补货' }}
              </b-button>
            </el-badge>
            <el-badge :value="checkedCount" class="ml-2" v-if="allow('B')">
              <b-button
                size="sm"
                variant="outline-danger"
                @click="$emit('noRestocking')"
                :disabled="!checkedCount"
              >
                {{ $l('btn_view_noRestocking') || '不补货' }}
              </b-button>
            </el-badge>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      top="10vh"
      width="900px"
      :close-on-click-modal="false"
      v-el-dialog-drag
      :modal-append-to-body="false"
      :modal="false"
    >
      <el-form ref="form" :model="form" size="mini">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$l('form_label_operate') || '运营人员'">
              <dict-select
                v-model="form.listOperateCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('form_placeholder_operate') || '请选择运营人员'
                "
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_amzStore') || '店铺'">
              <dict-select
                v-model="form.listAmzStoreCode"
                url="/ecom/amz/store/select"
                :placeholder="$l('form_placeholder_amzStore') || '请选择店铺'"
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_region') || '市场'">
              <dict-select
                v-model="form.listRegionCode"
                :body="{ dictType: 'region' }"
                url="/master/common/dict/biz"
                :options="{ label: 'value', value: 'value' }"
                :placeholder="$l('form_placeholder_region') || '请选择市场'"
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$l('form_label_amzSkuNo') || '亚马逊SKU'">
              <el-input
                v-model.trim="form.amzSkuNo"
                :placeholder="
                  $l('form_placeholder_amzSkuNo') || '请输入亚马逊SKU'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_asinCode') || 'ASIN'">
              <el-input
                v-model.trim="form.asinCode"
                :placeholder="$l('form_placeholder_asinCode') || '请输入ASIN'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_fnskuCode') || 'FNSKU'">
              <el-input
                v-model.trim="form.fnskuCode"
                :placeholder="$l('form_placeholder_fnskuCode') || '请输入FNSKU'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item
              :label="$l('form_label_amzGoodsSkuNo') || '产品SKU编号'"
            >
              <el-input
                v-model.trim="form.amzGoodsSkuNo"
                :placeholder="
                  $l('form_placeholder_amzGoodsSkuNo') || '请输入产品SKU编号'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_goodsName') || 'SKU名称'">
              <el-input
                v-model.trim="form.goodsName"
                :placeholder="
                  $l('form_placeholder_goodsName') || '请输入SKU名称'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_brand') || 'SKU品牌'">
              <dict-select
                v-model="form.listBrandCode"
                url="/master/common/dict/brandSelect"
                :placeholder="$l('form_placeholder_brand') || '请选择SKU品牌'"
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$l('INDEX.form_label_Spuno') || 'SPU编号'">
              <el-input
                v-model.trim="form.amzSpuNo"
                :placeholder="$l('INDEX.form_placeholder_SpuNo')"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('INDEX.table_label_succession') || '系列'">
              <dict-select
                v-model="form.listCollectionNo"
                url="/master/common/dict/biz"
                :placeholder="$l('INDEX.form_label_selectseries')"
                :body="collectionParams"
                clearable
                filterable
                multiple
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('INDEX.table_label_category') || '分类'">
              <el-cascader
                :options="categoryTree"
                :props="{
                  emitPath: false,
                  checkStrictly: false,
                  value: 'value',
                  label: 'label',
                }"
                v-model="form.detailCategoryCode"
                clearable
                filterable
                style="width: 100%"
                :showAllLevels="false"
              >
                <template slot-scope="{ node, data }">
                  <span>{{ data.label }}</span>
                  <span v-if="!node.isLeaf">
                    ({{ data.children.length }})
                  </span>
                </template>
              </el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$l('form_label_ncNo') || 'NC物料编码'">
              <el-input
                v-model.trim="form.ncNo"
                :placeholder="$l('form_placeholder_ncNo') || '请输入NC物料编码'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_scm') || '工厂'">
              <dict-select
                v-model="form.listScmCode"
                url="/master/common/dict/scmPartners"
                :placeholder="$l('form_placeholder_scm') || '请选择工厂'"
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_storeBrand') || '店铺品牌'">
              <dict-select
                v-model="form.listStoreBrandCode"
                url="/master/common/dict/brandSelect"
                :placeholder="
                  $l('form_placeholder_storeBrand') || '请选择店铺品牌'
                "
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item :label="$l('form_label_sellType') || '售卖方式'">
              <el-select
                v-model="form.listSellType"
                :placeholder="
                  $l('form_placeholder_sellType') || '请选择售卖方式'
                "
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              >
                <el-option
                  :label="$l('form_label_sellType_a') || '正常上架'"
                  value="A"
                ></el-option>
                <el-option
                  :label="$l('form_label_sellType_b') || '跟卖'"
                  value="B"
                ></el-option>
                <el-option
                  :label="$l('form_label_sellType_c') || '跨站点售卖'"
                  value="C"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_storeSkuStatus') || '售卖状态'"
            >
              <dict-select
                v-model="form.listStoreSkuStatus"
                :body="{ dictType: 'amzStoreSkuStatus' }"
                url="/master/common/dict/biz"
                :placeholder="
                  $l('form_placeholder_storeSkuStatus') || '请选择售卖状态'
                "
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('INDEX.form_label_goodsProperties') || '产品属性'"
              prop="goodsProperties"
            >
              <dict-select
                v-model="form.goodsProperties"
                url="/master/common/dict/biz"
                :body="{ dictType: 'goodsProperties' }"
                size="mini"
                clearable
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="5">
              <el-form-item :label="$l('form_label_salesPrice') || '售卖价格'">
                <br />
                <el-col :span="8">
                  <el-input-number
                    v-model="form.salesPriceStart"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    controls-position="right"
                    size="mini"
                    style="width: 100%"
                    :min="0.01"
                    :step="0.01"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    v-model="form.salesPriceEnd"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    controls-position="right"
                    style="width: 100%"
                    size="mini"
                    :min="0.01"
                    :step="0.01"
                  ></el-input-number>
                </el-col>
                <el-col :span="7">
                  <dict-select
                    v-model="form.salesCurrencyUnit"
                    url="/master/common/dict/biz"
                    :body="{ dictType: 'currencyUnit' }"
                    :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                    filterable
                    clearable
                    size="mini"
                    style="width:100%"
                  ></dict-select>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$l('form_label_upc') || 'UPC'">
              <el-input
                v-model.trim="form.upc"
                :placeholder="$l('form_placeholder_upc') || '请输入UPC'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$l('form_label_noMoreReplenishment') || '是否补货'"
            >
              <el-select
                v-model="form.noMoreReplenishment"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                clearable
                style="width: 100%"
              >
                <el-option value="N" :label="$l('INDEX.YES') || '是'" />
                <el-option value="Y" :label="$l('INDEX.NO') || '否'" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_isFocus') || '是否重点关注'">
              <el-select
                v-model="form.isFocus"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                clearable
                style="width: 100%"
              >
                <el-option value="Y" :label="$l('INDEX.YES') || '是'" />
                <el-option value="N" :label="$l('INDEX.NO') || '否'" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$l('form_label_salesTitle') || '售卖标题'">
              <el-input
                v-model.trim="form.salesTitle"
                :placeholder="
                  $l('form_placeholder_salesTitle') || '请输入售卖标题'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = { keyword: '' }
export default {
  props: { checkedCount: { type: Number, default: 0 } },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      collectionParams: { dictType: 'skuCollection' },
      masterCategoryParams: { parentCode: 'ABSHome' },
      categoryTree: [],
    }
  },
  mounted() {
    this.query()
    this.getTreeData()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    async getTreeData() {
      const res = await this.$api
        .ecomAmzSpuCategoryApi(this.masterCategoryParams)
        .catch(() => null)
      if (!res) return
      this.categoryTree = res.body?.data || []
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    exportFile() {
      this.$emit('exportFile', this.form)
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
